import { gql } from "apollo-boost";

/* 가맹점 본인 상점 결제내역 */
export const STORE_STOREORDER_LIST_QUERY = gql`
  query StoreStoreOrderList(
    $startSearchDate: String
    $endSearchDate: String
    $skip: Int
    $first: Int
  ) {
    StoreStoreOrderList(
      startSearchDate: $startSearchDate
      endSearchDate: $endSearchDate
      skip: $skip
      first: $first
    ) {
      storeOrders {
        id
        commonStatus
        currency
        value
        createdAt
        store {
          id
          name
        }
        cashier {
          id
          userId
          name
        }
        creator {
          id
          userId
          name
        }
        accountUserLedger {
          id
          title
          createdAt
        }
      }
      count
    }
  }
`;
